import React, { useEffect, useState } from "react";

import TextField from "@mui/material/TextField";
import "./product_entry.css";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";

import {
  addEditStepTwo,
  addStepTwo,
  addStepTwoSupplier,
  editStepTwoSupplier,
} from "../../redux/features/product.features";
import { fetchAllSuppliers } from "../../redux/features/suppliers.features";

import { useDispatch, useSelector } from "react-redux";
import store from "../../redux/store";
import Table from "../../components/table/Table";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";

const initialValues = {
  buyCurrency: "LKR",
  buyPrice: "0",
  buyPiece: "1", // not-paid , half paid , paid completed
  // purchasePaymentAmount:"",
  // purchasePaymentDate:"",
  sellPriceLocal: "0",
  sellLocalCurrency: "LKR",
  sellForeignersCurrency: "USD",
  sellPriceForeigners: "0",
  supplier: [],
  supplierTxt: "",
  priceVariant: false,
  exchangeRate: "360",
  sellPriceLocal2: "0",
  sellPriceForeigners2: "0",
};
const customerTableHead = [
  "firstName",
  "lastName",
  "homeAddress",
  // "businessAddress",
  "mobile",
  "email",
  "country",
  "city",
  "status",
];

const renderHead = (item, index) => <th key={index}>{item}</th>;

const ProductEditStepTwo = ({ setStepTwo }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAllSuppliers());
  }, [dispatch]);

  let productState = useSelector((state) => {
    return state.productReducer;
  });
  let suppliersState = useSelector((state) => {
    return state.suppliersReducer;
  });
  let { editProduct } = productState;
  let { stepTwo, loading } = editProduct;
  let { buyCurrency } = stepTwo;
  let { suppliers } = suppliersState;
  const [checked, setChecked] = React.useState(stepTwo.priceVariant || false);

  // const [values, setValues] = useState(stepTwo || initialValues);
  const [values, setValues] = useState(
    stepTwo.buyCurrency === "" ? initialValues : stepTwo
  );

  const [filteredSupplier, setFilteredSupplier] = useState(
    stepTwo.supplier.length !== 0 ? stepTwo.supplier : []
  );
  const [selectedSupplier, setSelectedSupplier] = useState(
    stepTwo.supplier.length !== 0 ? stepTwo.supplier : []
  );

  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });

    if (name === "supplierTxt" && !value) {
      setFilteredSupplier([]);
      setSelectedSupplier([]);
    }
    if (name === "exchangeRate") {
      if (checked) {
        setValues({
          ...values,
          [name]: value,
          ["sellPriceLocal"]:
            Number(values.sellPriceForeigners) * Number(value),
          ["sellPriceLocal2"]:
            Number(values.sellPriceForeigners2) * Number(value),
        });
      } else {
        setValues({
          ...values,
          [name]: value,
          ["sellPriceLocal"]:
            Number(values.sellPriceForeigners) * Number(value),
        });
      }
    }

    if (name === "sellPriceForeigners") {
      setValues({
        ...values,
        [name]: value,
        ["sellPriceLocal"]: Number(value) * Number(values.exchangeRate),
      });
    }

    if (name === "sellPriceForeigners2" && checked) {
      setValues({
        ...values,
        [name]: value,
        ["sellPriceLocal2"]: Number(value) * Number(values.exchangeRate),
      });
    }

    setTimeout(() => {
      verifyData();
    }, 1000);
  };

  const selectedProduct = (item) => {
    console.log("selected supplier ==>", item.firstName);
    let arr = [];
    arr.push(item);
    store.dispatch(editStepTwoSupplier(arr));
    setFilteredSupplier(arr);
  };

  const renderBody = (item, index) => {
    let selectedProductStore =
      store.getState().productReducer.editProduct.stepTwo.supplier;
    return (
      <tr
        className={
          selectedProductStore &&
          selectedProductStore.filter((x) => x.id === item.id).length !== 0
            ? "selected"
            : ""
        }
        onClick={() => selectedProduct(item)}
        key={index}
      >
        {/* <td>{item.id}</td> */}
        <td>{item.firstName}</td>
        <td>{item.lastName}</td>
        <td>{item.homeAddress}</td>
        {/* <td>{item.businessAddress}</td> */}
        <td>{item.mobile}</td>
        <td>{item.email}</td>
        <td>{item.country}</td>
        <td>{item.city}</td>
        <td>{item.status}</td>
      </tr>
    );
  };

  const searchSupplier = (e) => {
    const { name, value } = e.target;

    if (name === "supplierTxt" && !value) {
      setFilteredSupplier([]);
      setSelectedSupplier([]);
    }
    if (value !== undefined && value !== "") {
      let filterv = filterItems(value, suppliers);

      setFilteredSupplier([]);
      setSelectedSupplier([]);

      setTimeout(() => {
        setFilteredSupplier(filterv);
      }, 10);
    }
  };

  useEffect(() => {
    dispatch(fetchAllSuppliers());
  }, [dispatch]);

  const verifyData = () => {
    const finalValues = {
      buyCurrency: values.buyCurrency === "" ? "LKR" : values.buyCurrency,
      buyPrice: values.buyPrice === "" ? "0" : values.buyPrice,
      sellPriceLocal:
        values.sellPriceLocal === "" ? "0" : values.sellPriceLocal,
      sellPriceForeigners:
        values.sellPriceForeigners === "" ? "0" : values.sellPriceForeigners,
      sellPriceLocal2:
        values.sellPriceLocal2 === "" ? "0" : values.sellPriceLocal2,
      sellPriceForeigners2:
        values.sellPriceForeigners2 === "" ? "0" : values.sellPriceForeigners2,
      sellLocalCurrency:
        values.sellLocalCurrency === "" ? "LKR" : values.sellLocalCurrency,
      sellForeignersCurrency:
        values.sellForeignersCurrency === ""
          ? "USD"
          : values.sellForeignersCurrency,
      exchangeRate: values.exchangeRate === "" ? "360" : values.exchangeRate,
      buyPiece: values.buyPiece === "" ? "1" : values.buyPiece,
      priceVariant: checked,
    };

    setStepTwo(finalValues);
    dispatch(addEditStepTwo(finalValues));
    // setValues(finalValues);
    return finalValues;
  };

  useEffect(() => {
    verifyData();
    console.log("verify inside useEffect", verifyData());
  }, [stepTwo, checked]);

  const filterItems = (keyword, array) => {
    let query = keyword.toLowerCase();

    return array.filter(
      (item) => item.firstName.toLowerCase().indexOf(query) >= 0
    );
  };

  const handleCheck = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <div className="w-full flex-col items-center">
      <div className="mb-3 flex flex-col w-full border-2 border-spacing-3 border-gray-500">
        <div className="font-extrabold text-white p-3">Purchase Details</div>
        <hr></hr>
        <div className="flex">
          <div className="flex p-5 w-6/12 justify-between items-center">
            <TextField
              className=""
              required
              type="number"
              id="outlined-required"
              label="Buy Price"
              placeholder="999,999,999.00"
              defaultValue=""
              value={values.buyPrice}
              name="buyPrice"
              color="warning"
              onChange={handleChange}
            />

            <CustomSelectBox
              style={{ width: "122px" }}
              className=""
              items={["LKR", "USD"]}
              onChange={handleChange}
              title="Buy Currency"
              name="buyCurrency"
              value={values.buyCurrency}
              selectedValue={values.buyCurrency}
            />
          </div>
          <div className="flex p-5 w-6/12 justify-between items-center">
            <TextField
              className=""
              type="number"
              id="outlined-required"
              label="Purchase Pieces"
              placeholder="999,999,999.00"
              defaultValue=""
              value={values.buyPiece}
              onChange={handleChange}
              name="buyPiece"
              color="warning"
            />
          </div>
        </div>
      </div>
      <div className="mb-3 flex flex-col w-full border border-spacing-1  border-gray-500">
        <div className="font-extrabold text-white p-3 flex items-center justify-between">
          Sell Details
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  name="priceVariant"
                  checked={checked}
                  onChange={handleCheck}
                />
              }
              label="Price Variant"
            />
          </FormGroup>
        </div>
        <hr></hr>
        <div className="flex w-4/12 my-2 p-5">
          <TextField
            style={{ color: "white" }}
            className=""
            required
            id="outlined-required"
            label="exchangeRate "
            placeholder="999,999,999.00"
            defaultValue="360"
            type="number"
            value={values.exchangeRate}
            onChange={handleChange}
            name="exchangeRate"
            color="warning"
          />
        </div>
        <div className="flex">
          <div className="flex p-5 w-6/12 justify-between items-center">
            <TextField
              style={{ color: "white" }}
              className=""
              required
              type="number"
              id="outlined-required"
              label="Amount planned to sell (foreign) "
              placeholder="999,999,999.00"
              defaultValue="0"
              value={values.sellPriceForeigners}
              onChange={handleChange}
              name="sellPriceForeigners"
              color="warning"
            />

            <CustomSelectBox
              style={{ width: "122px" }}
              className=""
              items={["LKR", "USD"]}
              onChange={handleChange}
              title="Currency"
              name="sellForeignersCurrency"
              value={values.sellForeignersCurrency}
            />
          </div>
          <div className="flex p-5 w-6/12 justify-between items-center">
            <TextField
              style={{ color: "white" }}
              className=""
              required
              id="outlined-required"
              label="Amount planned to sell (local) "
              placeholder="999,999,999.00"
              defaultValue="0"
              type="number"
              value={values.sellPriceLocal}
              onChange={handleChange}
              name="sellPriceLocal"
              color="warning"
            />

            <CustomSelectBox
              style={{ width: "122px" }}
              className=""
              items={["LKR", "USD"]}
              onChange={handleChange}
              title="Currency"
              name="sellLocalCurrency"
              value={values.sellLocalCurrency}
            />
          </div>
        </div>
        {checked && (
          <div className="flex">
            <div className="flex p-5 w-6/12 justify-between items-center">
              <TextField
                style={{ color: "white" }}
                className=""
                required
                type="number"
                id="outlined-required"
                label="sell Price Foreigners 2"
                placeholder="999,999,999.00"
                defaultValue=""
                value={values.sellPriceForeigners2}
                onChange={handleChange}
                name="sellPriceForeigners2"
                color="warning"
              />

              <CustomSelectBox
                style={{ width: "122px" }}
                className=""
                items={["LKR", "USD"]}
                onChange={handleChange}
                title="Currency"
                name="sellForeignersCurrency2"
                value={values.sellForeignersCurrency}
              />
            </div>
            <div className="flex p-5 w-6/12 justify-between items-center">
              <TextField
                style={{ color: "white" }}
                className=""
                required
                id="outlined-required"
                label="sellPriceLocal2 "
                placeholder="999,999,999.00"
                defaultValue=""
                type="number"
                value={values.sellPriceLocal2}
                onChange={handleChange}
                name="sellPriceLocal2"
                color="warning"
              />

              <CustomSelectBox
                style={{ width: "122px" }}
                className=""
                items={["LKR", "USD"]}
                onChange={handleChange}
                title="Currency"
                name="sellLocalCurrency2"
                value={values.sellLocalCurrency}
              />
            </div>
          </div>
        )}
      </div>
      <div className="mb-3 flex flex-col w-full border border-spacing-1  border-gray-500">
        <div className="font-extrabold text-white p-3">Supplier Details</div>
        <hr></hr>
        <div className="flex">
          <div className="m-3 flex p-5 flex-col w-full justify-between items-center">
            <div className="flex justify-between  w-8/12">
              <TextField
                style={{ color: "white" }}
                id="outlined-required"
                label="Search supplier name"
                placeholder="john.."
                defaultValue=""
                value={values.supplierTxt}
                name="supplierTxt"
                color="warning"
                onChange={(e) => {
                  handleChange(e);
                  searchSupplier(e);
                }}
              />
              {filteredSupplier.length !== 0 && (
                <div
                  onClick={() => {
                    setValues({ ...values, ["supplierTxt"]: "" });
                    setFilteredSupplier([]);
                    setSelectedSupplier([]);

                    store.dispatch(addStepTwoSupplier([]));
                  }}
                  style={{ height: "54px" }}
                  className=" w-4/12 bx bx-reset p-5   text-white mx-2   flex justify-between items-center rounded cursor-pointer bg-red-500 text-2xl"
                >
                  {" "}
                  Reset supplier
                </div>
              )}
            </div>
            <div className="">
              {loading && <h1>Loading please wait...</h1>}
              {!loading &&
              filteredSupplier.length === 0 &&
              suppliers.length !== 0 &&
              (values.supplierTxt === undefined ||
                values.supplierTxt === "") ? (
                <div>
                  <Table
                    limit="5"
                    headData={customerTableHead}
                    renderHead={(item, index) => renderHead(item, index)}
                    bodyData={suppliers}
                    renderBody={(item, index) => renderBody(item, index)}
                  />
                </div>
              ) : filteredSupplier &&
                !loading &&
                filteredSupplier.length !== 0 &&
                values.supplierTxt !== "" ? (
                <div>
                  <h1>filters</h1>
                </div>
              ) : (
                values.supplierTxt !== "" && <p>No record available</p>
              )}

              {filteredSupplier &&
                !loading &&
                filteredSupplier.length !== 0 && (
                  <Table
                    limit="5"
                    headData={customerTableHead}
                    renderHead={(item, index) => renderHead(item, index)}
                    bodyData={filteredSupplier}
                    renderBody={(item, index) => renderBody(item, index)}
                  />
                )}
            </div>

            {selectedSupplier.length !== 0 && (
              <div className="my-3 bg-green-600 p-4 rounded text-white font-extrabold">
                {" "}
                SELECTED SUPPLIER IS :{" "}
                {JSON.stringify(selectedSupplier[0].firstName)}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductEditStepTwo;
